import { render, staticRenderFns } from "./feedback-bar.vue?vue&type=template&id=09b3bcc4&"
import script from "./feedback-bar.vue?vue&type=script&lang=js&"
export * from "./feedback-bar.vue?vue&type=script&lang=js&"
import style0 from "./feedback-bar.vue?vue&type=style&index=0&id=09b3bcc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports